import { AxiosRequestConfig } from "axios";
import { apis } from "service";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const get_customers = BASE_URL + 'FiAQK2sE/customer_via_number_v3'
const get_live_rates = BASE_URL + 'FiAQK2sE/fx_live_rates'
const create_order = BASE_URL + 'FiAQK2sE/create_order_forex_v3'
const calculation = BASE_URL + 'FiAQK2sE/forex_price_breakdown_v3'
const get_address_by_id = BASE_URL + 'FiAQK2sE/fetch_address'
const add_contact = BASE_URL + `FiAQK2sE/add_contact_v3`

export interface CustomerResponse {
    phone_number: string;
    full_name: string;
    email: string;
    pan_no: string;
    id: number;
}

export interface CalculationPayload {
    amount: number;
    type: string;
}

export interface CalculationResponse {
    amount: number;
    CGST: number;
    SGST: number;
    roundOff: number;
    service_charge: number;
    gst: {
      slab1: number;
      slab2: number;
      slab3: number;
      total_taxable_amount: number;
      gst: number;
    };
    total_payable: {
      grand_total: number;
    };
  }

export interface CalculationPayload {
    amount: number;
    type: string;
}

export interface CalculationResponse {
    amount: number;
    CGST: number;
    SGST: number;
    roundOff: number;
    service_charge: number;
    gst: {
      slab1: number;
      slab2: number;
      slab3: number;
      total_taxable_amount: number;
      gst: number;
    };
    total_payable: {
      grand_total: number;
    };
  }

  export type OrderPayload = {
    purpose: string;
    end_date: string; // ISO format e.g., "2025-05-23"
    start_date: string;
    type_of_order: "buy" | "sell";
    opportunity_id: number;
    products: {
      customers_id: number | null;
      forex_type: "Sale" | "Purchase";
      currency_have: string;
      quantity: number;
      card_type: "multi currency" | "single currency";
      product_id: number;
      currency_want: string;
      rate: number;
      local_id: string; // new field added
      name?: string;
      pan_no?: string;
      phone_number?: string;
      email?: string;
    }[];
    delivery_details: Partial<{
      local_id: string[]; // links to one or more products
      customers_id: number;
      address_id: string; // UUID string
      delivery_mode: string;
      delivery_id: string;
      delivery_channel: string;
      address_line_1: string;
      address_line_2: string;
      city: string;
      state: string;
      pincode: string;
      country: string;
    }[]>;
  };
  
  

export const getCustomers = async (number: string): Promise<CustomerResponse[]> => {
    const payload: AxiosRequestConfig = {
        params: {
            number
        }
    }
    const response = await apis.get(get_customers, payload)
    return response.data as CustomerResponse[]
}

export const getLiveRates = async ({currency, type, fx_product}:{currency:string, type: string, fx_product:string}): Promise<any> => {
    const payload: AxiosRequestConfig = {
      data: {
        currency: currency,
        type: type,
        fx_product: fx_product,
      },
    };
    const response = await apis.post(get_live_rates, payload)
    return response.data
}

export const adddNewContact = async ({name, pan_no, phone_number, email}:{name:string, pan_no: string, phone_number:string, email:string}): Promise<any> => {
    const payload: AxiosRequestConfig = {
      data: {
        name: name,
        pan_no: pan_no,
        phone_number: phone_number,
        email: email,
      },
    };
    const response = await apis.post(add_contact, payload)
    return response.data
}

export const createGenericOrder = async (data:OrderPayload): Promise<any> => {
    const payload: AxiosRequestConfig<OrderPayload> = {
        data: data
    }
    return await apis.post(create_order, payload)
}

export const getCalculations = async (data: CalculationPayload): Promise<CalculationResponse> => {
    const payload: AxiosRequestConfig<CalculationPayload> = {
        params: data
    }
    return (await apis.get(calculation, payload)).data
}

export const getAddressById = async (data:{customers_id: number}):Promise<{address_id:{id:string}[]|any[]}> => {
    const payload :AxiosRequestConfig<{customers_id: number}> = {
        params: data
    }
    return (await apis.get(get_address_by_id, payload)).data
}